import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Image, Button, Carousel, Modal, Accordion } from 'react-bootstrap';
import { Fade } from "react-awesome-reveal";
import { db } from '../../firebase/firebase';
import { collection, getDocs } from "firebase/firestore";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


import reportsImg from '../../assets/Carousel/reports.png';
import insightsImg from '../../assets/Carousel/insights.png';
import trackingImg from '../../assets/Carousel/tracking.png';
import analyticsImg from '../../assets/Carousel/analytics.png';
import recommendationsImg from '../../assets/Carousel/recommendations.png';
import reportsImgMobile from '../../assets/Carousel/reports-mobile.png';
import insightsImgMobile from '../../assets/Carousel/insights-mobile.png';
import trackingImgMobile from '../../assets/Carousel/tracking-mobile.png';
import analyticsImgMobile from '../../assets/Carousel/analytics-mobile.png';
import recommendationsImgMobile from '../../assets/Carousel/recommendations-mobile.png';
import linkedin from '../../assets/linkedin.svg';


import heroImagePlaceholder from '../../assets/Homepage/image-30.png';
import chartWatchList from '../../assets/Homepage/chart-watch-list.png';

import './HomePage.css';
import { useNavigate } from 'react-router-dom';
import ComplianceInfoModal from '../Compliance/ComplianceInfoModal';

// PRICING PLANS SCROLL AREA
function PricingScrollArea({ pricingPlans, navigate }) {
  const scrollRef = useRef(null);

  function getRiskBannerStyle(riskLevel) {
    switch (riskLevel) {
      case 2:
        return { background: 'linear-gradient(90deg, #b3cfff, #5b9aff)', height: '8px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' };
      case 3:
        return { background: 'linear-gradient(90deg, #a8ffde, #1fc8db)', height: '8px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' };
      case 4:
        return { background: 'linear-gradient(90deg, #ffe5b3, #ff9900)', height: '8px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' };
      case 5:
        return { background: 'linear-gradient(90deg, #ffb3b3, #ff3b3b)', height: '8px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' };
      default:
        return null; // No banner for riskLevel 1
    }
  }

  function getRiskLabel(riskLevel) {
    switch (riskLevel) {
      case 1: return 'Lowest';
      case 2: return 'Low';
      case 3: return 'Medium';
      case 4: return 'High';
      case 5: return 'Highest';
      default: return '';
    }
  }

    return (
    <div className="relative">
      <div ref={scrollRef} className="overflow-x-auto scrollbar-thin scrollbar-thumb-blue-500 w-full">
        <div className="flex gap-2 min-w-max px-4 py-4">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`flex-shrink-0 w-[80vw] max-w-xs md:w-[320px] md:max-w-[340px] rounded-xl flex flex-col p-6 text-center border shadow-md relative overflow-hidden ${
              plan.inactive 
                ? 'bg-gray-100 border-gray-300 opacity-60' 
                : 'bg-white border-gray-200'
            }`}>
              
              {/* Inactive overlay with innovative design */}
              {plan.inactive && (
                <>
                  {/* Diagonal stripe overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-400/20 to-transparent pointer-events-none"></div>
                  
                  {/* Inactive badge */}
                  <div className="absolute top-1 right-1 bg-gray-500 text-white text-xs px-2 py-1 rounded-full font-medium z-10">
                    Temporarily Unavailable
                  </div>
                  
                  {/* Subtle pattern overlay */}
                  <div className="absolute inset-0 opacity-5">
                    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <pattern id="inactive-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                          <circle cx="10" cy="10" r="1" fill="currentColor"/>
                        </pattern>
                      </defs>
                      <rect width="100%" height="100%" fill="url(#inactive-pattern)"/>
                    </svg>
                  </div>
                </>
              )}
              
              {/* Risk banner with tooltip */}
              {plan.riskLevel > 1 && (
                <div style={getRiskBannerStyle(plan.riskLevel)} />
              )}
              
              <h3 className={`text-xl font-bold mb-4 ${plan.inactive ? 'text-gray-500' : 'text-blue-900'}`}>
                {plan.name}
              </h3>
              
              <div className="mb-2 flex items-center justify-center">
                <span className={`text-3xl font-bold ${plan.inactive ? 'text-gray-400' : 'text-blue-800'}`}>
                  {plan.price}
                </span>
                <span className={`ml-1 text-sm ${plan.inactive ? 'text-gray-400' : 'text-gray-500'}`}>
                  {plan.priceDetails}
                </span>
              </div>
              
              <p className={`text-xs mb-4 ${plan.inactive ? 'text-gray-400' : 'text-gray-400'}`}>
                {plan.period}
              </p>
              
              {/* list-none pl-0: explicit now that Tailwind preflight is off (audit round-2) */}
              <ul className="list-none pl-0 text-left mb-6 space-y-2">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex} className={`flex items-center text-sm ${
                    plan.inactive ? 'text-gray-500' : 'text-gray-700'
                  }`}>
                    <svg className={`w-4 h-4 mr-2 ${plan.inactive ? 'text-gray-400' : 'text-blue-500'}`} 
                         fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <button
                className={`rounded-lg px-4 py-2 font-semibold transition mt-auto ${
                  plan.inactive
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
                onClick={plan.inactive ? undefined : () => navigate('/query?type=subscriptionAccess')}
                disabled={plan.inactive}
              >
                {plan.inactive ? 'Subscribe' : 'Subscribe'}
              </button>
            </div>
          ))}
        </div>
      </div>
      {/* Arrow indicator, only on mobile */}
      <div className="block md:hidden pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 z-10">
        <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
          <circle cx="16" cy="12" r="12" fill="#3871E0" fillOpacity="0.15"/>
          <path d="M10 8l4 4-4 4" stroke="#3871E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
}

const HomePage = () => {
    const navigate = useNavigate()

    const [pricingPlans, setPricingPlans] = useState([]);
    const [loadingPlans, setLoadingPlans] = useState(true);

    useEffect(() => {
        const fetchPricingPlans = async () => {
            setLoadingPlans(true);
            try {
                const plansCollectionRef = collection(db, "pricingPlans");
                const data = await getDocs(plansCollectionRef);
                const fetchedPlans = data.docs
                    .map(doc => ({ ...doc.data(), id: doc.id }))
                    .sort((a, b) => a.order - b.order);
                setPricingPlans(fetchedPlans);
            } catch (error) {
                console.error("Error fetching pricing plans: ", error);
                // Optionally, set an error state to show a message to the user
            } finally {
                setLoadingPlans(false);
            }
        };

        fetchPricingPlans();
    }, []);

    const carouselItems = [
        { img: recommendationsImg, imgMobile: recommendationsImgMobile, alt: "Recommendations", title: "Recommendations", text: "Expert stock recommendations for informed decisions" },
        { img: reportsImg, imgMobile: reportsImgMobile, alt: "Reports", title: "Reports", text: "Detailed market analysis and research reports" },
        { img: insightsImg, imgMobile: insightsImgMobile, alt: "Insights", title: "Insights", text: "Deep market insights and trend analysis" },
        { img: trackingImg, imgMobile: trackingImgMobile, alt: "Tracking", title: "Tracking", text: "Real-time portfolio and performance tracking" },
        { img: analyticsImg, imgMobile: analyticsImgMobile, alt: "Analytics", title: "Analytics", text: "Advanced analytics and market metrics" },
        //{ img: advisoryImg, alt: "Advisory", title: "Advisory", text: "Expert financial advisory services" } // Uncomment if needed
    ];

    const trustItems = [
        {
            category: "RECOMMENDATIONS",
            quote: "“Right Spade's stock recommendations are spot on! Their Buy and Sell calls have helped me make confident, well-timed investment decisions.”",
            author: "– Somanath (IT & Security)",
            link: "https://www.linkedin.com/in/somanath-ng-b3a82a10/"
        },
        {
            category: "TRACKING",
            quote: "“I love how easy it is to track stock targets and performance. The structured insights give me a clear roadmap for my investments.”",
            author: "– Debashish (Real Estate)",
            link: "https://www.linkedin.com/in/debashish-sadangi-4b115519"    
        },
        {
            category: "REPORTS",
            quote: "“The in-depth research reports go beyond basic analysis. They break down financials, market trends, and valuations, making investing simpler and more strategic.”",
            author: "– Alex Peter (Venture Capitalist)",
            link: "https://www.linkedin.com/in/alex-peter-6728212b?"
        }
    ];

    // Pricing Plans Data is now fetched from Firebase

    // FAQ Data
    // FAQ Data
    const faqData = [
        {
            "question": "What is Right Spade?",
            "answer": "Right Spade is a SEBI-registered research analyst firm providing independent stock research and recommendations."
        },
        {
            "question": "Is Right Spade SEBI registered?",
            "answer": "Yes, we operate under SEBI (Research Analysts) Regulations, 2014 and follow strict compliance guidelines."
        },
        {
            "question": "Do you offer investment advice or manage portfolios?",
            "answer": "No. We provide research-based stock recommendations, not personalized financial advice or portfolio management."
        },
        {
            "question": "Are returns guaranteed?",
            "answer": "No. Investments in the stock market are subject to market risks.\nReturns cannot be guaranteed, and past performance is not indicative of future results."
        },
        {
            "question": "What are the subscription plans?",
            "answer": "* Prime: ₹5,000 + taxes (Quarterly) | ₹20,000 + taxes (Yearly)\nUp to 3 stocks/quarter\n1 multibagger/year (Yearly only)\nSmall & Mid Cap coverage\n\n* Elite: ₹10,000 + taxes (Quarterly) | ₹40,000 + taxes (Yearly)\nUp to 5 stocks/quarter\n1 multibagger/year (Yearly only)\nSmall, Mid & Large Cap coverage\nMarket insights included"
        },
        {
            "question": "Can I cancel or get a refund?",
            "answer": "Refunds are governed by our Service Agreement.\nIf approved, they are processed on a prorated basis for the remaining subscription period."
        },
        {
            "question": "Where can I access stock recommendations?",
            "answer": "On our secure portal.\nYou must log in with an active subscription using your registered email ID to view stock recommendations."
        },
        {
            "question": "Do you provide intraday or F&O trading tips?",
            "answer": "No. We focus exclusively on long-term equity research.\nWe do not offer intraday or derivative (F&O) trading tips."
        },
        {
            "question": "Are there any conflicts of interest or financial interests?",
            "answer": "No.\nNeither the company nor its associates or analysts (or their relatives) have any financial interest in covered companies.\nNo party owns 1% or more of any such stock.\nThere are no material conflicts of interest during publication."
        },
        {
            "question": "How can I contact support?",
            "answer": "You can contact our team via email or through the Contact Us page on our website."
        }
    ];

    // State for controlling the carousel index
    const [activeIndex, setActiveIndex] = useState(0);

    // State for SEBI Registered Modal
    const [showSebiModal, setShowSebiModal] = useState(false);

    // State for Compliance Info Modal
    const [showComplianceModal, setShowComplianceModal] = useState(false);

    const handleSelect = (selectedIndex, e) => {
        setActiveIndex(selectedIndex);
    };

    // SEBI Modal Handlers
    const handleShowSebiModal = () => setShowSebiModal(true);
    const handleCloseSebiModal = () => setShowSebiModal(false);

    // Compliance Info Modal Handlers
    const handleShowComplianceModal = () => setShowComplianceModal(true);
    const handleCloseComplianceModal = () => setShowComplianceModal(false);

    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY === 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="homepage-container">
            <div style={{ marginTop: '142px' }}>

                {/* Hero Section */}
                <section className="hero-section-homepage1">
                    <div className='w-100'>
                        <Row className="align-items-center" >

                            <Fade direction="left" triggerOnce cascade damping={0.1}>
                                <div className="hero-text-content-homepage" style={{ textAlign: 'center' }}>
                                    <h1 className="hero-text-content-homepage">Equity Investments, Done Right!</h1>
                                    <p className="hero-text-content-homepage p">
                                        {/* Real <button>: the span with role="button" only responded to
                                            Enter, not Space (WCAG 2.1.1). The accessible name states the
                                            action rather than the claim, and aria-haspopup warns that a
                                            dialog opens — both from the NVDA end-user test, 27 Jul 2026. */}
                                        <button
                                            type="button"
                                            className="sebi-registered-link"
                                            onClick={handleShowSebiModal}
                                            aria-haspopup="dialog"
                                            aria-expanded={showSebiModal}
                                            aria-label="View credentials: SEBI registration details"
                                        >
                                            SEBI Registered
                                        </button>
                                        , expert-backed stock recommendations and deep market insights to help you invest with confidence and clarity.
                                    </p>
                                    <Button variant="primary" onClick={() => { navigate('/login') }} className="get-started-button">Get Started</Button>
                                </div>
                            </Fade>
                        </Row>
                    </div>
                </section>

                {/* Hero Image Section */}
                <section className={`hero-image-section ${visible ? 'blur-visible' : 'blur-invisible'}`}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={10} lg={8} className='image-wrap'> {/* Adjust column size as needed */}
                                <Fade direction="up" triggerOnce>
                                    <div>
                                        <Image
                                            src={heroImagePlaceholder}
                                            alt=""
                                            fluid // Makes the image responsive
                                            className="hero-section-image" // Class for styling
                                        />
                                        <div className="chart-watch-list-container">
                                            <Image
                                                src={chartWatchList}
                                                alt=""
                                                fluid // Makes the image responsive
                                            />
                                        </div>
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Recommendations Section with Carousel */}
                <section className="recommendations-section section-padding-homepage section-margin-top">
                    <div>
                        <Row className="justify-content-center">
                        <h2 className="homepage-section-title mb-4">Discover. Invest. Grow.</h2>
                            <Col md={12}>
                                <Fade triggerOnce>
                                    {/* Custom Indicators */}
                                    <div className="custom-carousel-indicators mb-3"> {/* Added margin-bottom */}
                                        {carouselItems.map((item, index) => (
                                            <Button
                                                key={index}
                                                variant="link"
                                                className={`custom-indicator-item ${index === activeIndex ? 'active' : ''}`}
                                                onClick={() => handleSelect(index)} // Set active index on click
                                            >
                                                {item.title}
                                            </Button>
                                        ))}
                                    </div>

                                    {/* Carousel Component */}
                                    <Carousel
                                        activeIndex={activeIndex} // Control index via state
                                        onSelect={handleSelect} // Update state on slide change
                                        interval={1500}
                                        className="recommendations-carousel"
                                        indicators={false} // Disable default indicators
                                        controls={true}
                                        fade
                                    >
                                        {carouselItems.map((item, index) => (
                                            <Carousel.Item key={index}>
                                                <div className="carousel-content">
                                                    <picture>
                                                        <source media="(max-width: 799px)" srcSet={item.imgMobile} />
                                                        <source media="(min-width: 800px)" srcSet={item.img} />
                                                        <img src={item.img} alt={item.alt} className='carousel-image' />
                                                    </picture>
                                                </div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                </Fade>
                            </Col>
                        </Row>
                    </div>
                </section>

                {/* Why Investors Trust Right Spade Section */}
                <section className="trust-section section-padding-homepage section-margin-top">
                    <Container>
                        <Fade direction="down" triggerOnce>
                            <h2>Why Investors Trust Right Spade?</h2>
                            <p className="section-subtitle">
                                Real insights. Real results. See how our expert-backed research empowers investors like you.
                            </p>
                        </Fade>
                        {/* Horizontally scrollable trust items */}
                        <div className="relative">
                            <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-blue-500 w-full">
                                <div className="flex gap-2 min-w-max px-4 py-4 justify-center">
                                    {trustItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex-shrink-0 w-[80vw] max-w-sm md:w-[400px] md:max-w-[420px] bg-white rounded-xl flex flex-col p-6 text-left border shadow-md"
                                        >
                                            {/* <Fade direction="up" className="h-100" delay={index * 150} triggerOnce> */}
                                                <div className="trust-item">
                                                    <p className="trust-item-category">{item.category}</p>
                                                    <p className="trust-item-quote">{item.quote}</p>
                                                    <p className="trust-item-author">
                                                        {item.author}
                                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                            <img src={linkedin} alt={`${item.author} on LinkedIn`} className="linkedin-icon" />
                                                        </a>
                                                    </p>
                                                </div>
                                            {/* </Fade> */}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* Arrow indicator, only on mobile */}
                            <div className="block md:hidden pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 z-10">
                                <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
                                    <circle cx="16" cy="12" r="12" fill="#3871E0" fillOpacity="0.15"/>
                                    <path d="M10 8l4 4-4 4" stroke="#3871E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </Container>
                </section>

                {/* Pricing Plans Section */}
                <section className="pricing-section section-padding-homepage section-margin-top">
                    <div className="container mx-auto">
                        
                            <h2 className="homepage-section-title">Pricing Plans</h2>
                        
                        {loadingPlans ? (
                            <div className="text-center">
                                <p>Loading plans...</p>
                            </div>
                        ) : (
                            <PricingScrollArea pricingPlans={pricingPlans} navigate={navigate} />
                        )}
                    </div>
                </section>

                {/* FAQ Section */}
                <section className="faq-section section-padding-homepage section-margin-top">
                    <Container>
                        <Fade direction="down" triggerOnce>
                            <h2 className="homepage-section-title">Frequently Asked Questions</h2>
                        </Fade>
                        <Row className="justify-content-center mt-4">
                            <Col md={10} lg={9}>
                                <Fade direction="up" triggerOnce>
                                    <Accordion defaultActiveKey="0" className="faq-accordion">
                                        {faqData.map((item, index) => (
                                            <Accordion.Item eventKey={String(index)} key={index}>
                                                {/* h3: one level below the section's h2 (audit round-2) */}
                                                <Accordion.Header as="h3">{item.question}</Accordion.Header>
                                                <Accordion.Body>

                                                    {item.answer.split('\n').map((line, lineIndex) => {
                                                        const trimmedLine = line.trim();
                                                        if (trimmedLine.startsWith('* ')) {
                                                            // Render bullet points as list items (simple approach)
                                                            // Using a styled paragraph for simplicity here.
                                                            // For semantic <ul><li>, more complex grouping logic needed.
                                                            return (
                                                                <p key={lineIndex} className="faq-bullet-item">
                                                                    <span className="faq-bullet">•</span>
                                                                    {trimmedLine.substring(2)} {/* Remove '* ' */}
                                                                </p>
                                                            );
                                                        } else if (trimmedLine.length > 0) {
                                                            // Render normal lines as paragraphs
                                                            return <p key={lineIndex}>{trimmedLine}</p>;
                                                        } else {
                                                            // Handle potentially empty lines resulting from split
                                                            // You could render a <br />, or null to ignore them
                                                            return null; // Ignore empty lines
                                                        }
                                                    })}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                </Fade>
                            </Col>
                        </Row>
                    </Container>
                </section>

            </div>

            {/* Floating Action Button for Compliance */}
            {/* <Button
                variant="danger"
                className="compliance-side-tab"
                onClick={handleShowComplianceModal}
                aria-label="Compliance & Regulatory Info"
            >
                <span>COMPLIANCE</span>
            </Button> */}

            {/* The dialog had no accessible name — NVDA announced only "dialog".
                aria-labelledby points at the (visually hidden) title. */}
            <Modal
                show={showSebiModal}
                onHide={handleCloseSebiModal}
                centered
                aria-labelledby="sebiModalTitle"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="sebiModalTitle" className="visually-hidden">
                        SEBI registration details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Right Spade (SEBI Registration No: INH000018799) is a SEBI-registered Research Analyst offering expert-backed stock recommendations. Our research blends fundamental, technical, and market trend analysis to identify opportunities. Investments in securities are subject to market risks—refer to our <a href="/legal#terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> and <a href="/legal#privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> before investing.
                    </p>
                </Modal.Body>
            </Modal>

            <ComplianceInfoModal show={showComplianceModal} handleClose={handleCloseComplianceModal} />

        </div>
    );
};

export default HomePage;